import { render, staticRenderFns } from "./CancelBookedNoticeCard.vue?vue&type=template&id=35e73a2a&scoped=true"
import script from "./CancelBookedNoticeCard.vue?vue&type=script&lang=js"
export * from "./CancelBookedNoticeCard.vue?vue&type=script&lang=js"
import style0 from "./CancelBookedNoticeCard.vue?vue&type=style&index=0&id=35e73a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e73a2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
